// Retargeting query params (eg: ?ret=va)
// This way we can identify the source of the retargeting traffic

// Ventes Avenues
export const VENTES_AVENUES = 'va'
